import React from 'react'
// require('bootstrap/js/dist/modal')
const Modal = (props) => {
    return (
        <div>
            <div className="modal" id={props.modalId}>
                <div className={"modal-dialog " + props.modalWidth}>
                    <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title">{props.header}</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>

                        <div className="modal-body">
                            {props.children}
                        </div>

                        <div className="modal-footer">
                            {props.action!==""?<button type="button" className="btn btn-success">{props.action}</button>:""}
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
export default Modal;